// NeededProductsTable.js
import React, { useState } from "react";
import {
  Card, CardBody, Row, Col, Input, Collapse, Button
} from "reactstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const NeededProductsTable = ({ products }) => {
  const { t } = useTranslation();
  const [showMissingOnly, setShowMissingOnly] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortKey, setSortKey] = useState("name");
  const [sortAsc, setSortAsc] = useState(true);
  const [totalsOpen, setTotalsOpen] = useState(true);

  const toggleSort = (key) => {
    if (sortKey === key) {
      setSortAsc(!sortAsc);
    } else {
      setSortKey(key);
      setSortAsc(true);
    }
  };

  const filtered = products
    .filter(p =>
      (!showMissingOnly || p.available < 0) &&
      Object.values(p).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    .sort((a, b) => {
      const valA = a[sortKey];
      const valB = b[sortKey];
      return sortAsc
        ? valA > valB ? 1 : -1
        : valA < valB ? 1 : -1;
    });

  return (
    <Card className="mb-4">
      <CardBody>
        <Row className="mb-2 align-items-center">
          <Col md="6">
            <Button color="link" onClick={() => setTotalsOpen(!totalsOpen)}>
              {totalsOpen ? "▼" : "▶"} {t("Total Needed Products")}
            </Button>
          </Col>
          <Col md="6" className="text-end">
            <Input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={t("Search products...")}
              style={{ maxWidth: 200, display: "inline-block", marginRight: 10 }}
            />
            <input
              type="checkbox"
              checked={showMissingOnly}
              onChange={() => setShowMissingOnly(!showMissingOnly)}
              style={{ marginRight: 6 }}
            />
            <label>{t("Show Only Missing")}</label>
          </Col>
        </Row>

        <Collapse isOpen={totalsOpen}>
          <div className="table-responsive" style={{ maxHeight: 500, overflowY: "auto" }}>
            <table className="table table-bordered table-sm align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th onClick={() => toggleSort("id")} style={{ cursor: "pointer" }}>
                    {t("Product ID")} {sortKey === "id" ? (sortAsc ? "↑" : "↓") : ""}
                  </th>
                  <th onClick={() => toggleSort("name")} style={{ cursor: "pointer" }}>
                    {t("Name")} {sortKey === "name" ? (sortAsc ? "↑" : "↓") : ""}
                  </th>
                  <th onClick={() => toggleSort("quantity")} style={{ cursor: "pointer" }}>
                    {t("Needed Qty")} {sortKey === "quantity" ? (sortAsc ? "↑" : "↓") : ""}
                  </th>
                  <th onClick={() => toggleSort("stock")} style={{ cursor: "pointer" }}>
                    {t("Available Stock")} {sortKey === "stock" ? (sortAsc ? "↑" : "↓") : ""}
                  </th>
                  <th onClick={() => toggleSort("available")} style={{ cursor: "pointer" }}>
                    {t("Difference")} {sortKey === "available" ? (sortAsc ? "↑" : "↓") : ""}
                  </th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(prod => (
                  <tr key={prod.id}>
                    <td>{prod.id}</td>
                    <td>{prod.name}</td>
                    <td>{prod.quantity}</td>
                    <td>{prod.stock}</td>
                    <td style={{ color: prod.available < 0 ? "red" : "inherit" }}>
                      {prod.available}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Collapse>
      </CardBody>
    </Card>
  );
};

NeededProductsTable.propTypes = {
  products: PropTypes.array.isRequired
};

export default NeededProductsTable;
